module.exports = __webpack_public_path__ + "img/wb1@2x.50abcabe.png";